<form [formGroup]="form">
  <div>
    <mat-chip-listbox [formControlName]="controlName">
      <mat-chip-option
        *ngFor="let trailerType of trailerTypes$ | async"
        [ngClass]="{'chip-selected' : inputControl?.value === trailerType.code}"
        [selected]="inputControl?.value === trailerType.code"
        [value]="trailerType?.code"
        [attr.aria-label]="trailerType?.code"
        [disabled]="disabled">
        {{ 'yardControl.lists.trailerType.' + trailerType?.code | translate }}
      </mat-chip-option>
    </mat-chip-listbox>

    <mat-error *ngIf="inputControl?.errors">
      <ng-template [appMatErrorMessages]="inputControl" let-message>{{ message }}</ng-template>
    </mat-error>
  </div>
</form>
